import { BaseSyntheticEvent, ReactNode } from 'react';
import { valueof } from 'types/typescript-utils';
import { FORM_PLACEHOLDERS } from 'features/authentication/utils/constants';

export enum AuthValue {
    Login = '0',
    SignUp = '1',
}

export enum FormErrorMessages {
    EmailInvalid = 'Invalid email. Required format: name@company.com',
    RegularFieldLength = 'Character limit exceeded (max 128)',
}

export type DisplayEmailFormText = {
    title: string;
    subTitle: ReactNode;
    emailInputPlaceholders: FormPlaceholders;
    buttonDisplayText: string;
    returnLoginDescription: string;
    returnLoginButton: string;
};

export type FormPlaceholders = valueof<typeof FORM_PLACEHOLDERS>;

export interface LoginValuesToValidate {
    email?: boolean;
    password?: boolean;
}

export interface SignupValuesToValidate extends LoginValuesToValidate {
    firstName?: boolean;
    lastName?: boolean;
    companyName?: boolean;
}

export interface EmailValuesToValidate {
    email?: boolean;
}

export interface PasswordValuesToValidate {
    newPassword?: boolean;
    confirmPassword?: boolean;
    email?: boolean;
}

export type FormValuesToValidate =
    | LoginValuesToValidate
    | SignupValuesToValidate
    | EmailValuesToValidate
    | PasswordValuesToValidate;

export interface CustomErrorInputProps {
    id: string;
    type?: string;
    value: string;
    name: string;
    onChange: (event: BaseSyntheticEvent) => void;
    onBlur: (valToValidate: FormValuesToValidate) => void;
    placeholder: string;
    errorMessage?: string;
    required?: boolean;
    readOnly?: boolean;
}

export enum SocialConnectAction {
    Login = 'login',
    Signup = 'sign up',
}

export interface SocialConnectProps {
    actionText: SocialConnectAction;
    onSuccessCallback?: (platform: string) => void;
    onFailureCallback?: (error: unknown) => void;
}
export interface WebSightsData {
    WS_companyName?: string;
    WS_employeeCount?: number;
    WS_industries?: string;
}
